import { BasePresenter } from "@presenters/base/base.presenter";
import { useSelector } from "react-redux";
import { IFollowup, ILang } from "@models/*";
import { Constants, Dictionary, moment, Utilities, Enums } from "@utils";
import {  FollowupService, IFollowupService } from "@services/proyecta/followup.service";

export class FollowupPresenter extends BasePresenter<any> {
    public currentLabels: Dictionary<string, string>;
    public followupLabels: Dictionary<string, string>;
    public formMasters: any;
    public followupData: IFollowup[];
    public infoByProject: any[]
    public currentLang: ILang;
    private followupService: IFollowupService;
    public params: any;

    constructor(view: any) {
        super(view);
        this.followupData = useSelector(this.context.followupStore.selectFollowupData);
        this.formMasters = useSelector(this.context.followupStore.selectFormMasters);
        this.currentLabels = useSelector(this.context.sessionStore.selectLabels);
        this.followupLabels = useSelector(this.context.followupStore.selectLabels);
        this.currentLang = useSelector(this.context.sessionStore.selectLang) as any;
        this.params = useSelector(this.context.sessionStore.selectParams);

        this.followupService = new FollowupService();
    }

    public async initialize(reload?: boolean){ 
        this.dispatcherProgress(30);
        this.dispatcherPendingLoad(1);
        this.dispatcherSetLoading();

        this.dispatcherProgress(50); 
          
        this.dispatcher(this.context.followupStore.getLabels());
        this.dispatcher(this.context.followupStore.getAllFormMasters()); 
        this.dispatcher(this.context.followupStore.getOnlyFollowupData()); 

        this.dispatcherProgress(80);  

        const columns = await this.followupService.getDefinitionColumnsIndex(this.currentLang?.id);
        this.view.state.setDataColumns(columns);
        
    }

    public async unSetLoading(){
        setTimeout(() => {
            this.dispatcherProgress(90); 
        });
        setTimeout(() => {
            this.dispatcherUnsetSetLoading();
        }, 1000);
    }

    public getDataSubProjects(followData: IFollowup[], masters: any){
        let newData: any[] = []    
        for (const data of followData) {
            let idsFinancers = data.IdFinanciador?.split(", ")
            let findSubCode = null
            if(!!idsFinancers) findSubCode = idsFinancers.map((y: any) => masters.allFinancers.find((x: any) => x.Id === Number(y))?.Title).join(", ")
            let country = !!data.IdPais 
                ? masters.countries.find((x: any) => x.Id === Number(data.IdPais))?.Title 
                : masters.regions.find((x: any) => x.Id === Number(data.IdRegion))?.Title || ''
            let intLine = masters.interventionLines.find((x: any) => x.Id === Number(data.IdLineaIntervencion))
            let status = Number(data.EstadoSubproyecto)

            if(status === this.formMasters.followupState.find((x: any) => x.OCTAVIACodigo === Enums.FollowupState.valid)?.Id){
                let canEdit = this.getTotalPermissions(country)
                newData.push({
                    id: data.Id,
                    project: `${data.PPresCodProy || ''} - ${data.TituloProyecto || ''}`, 
                    subProject: `${data.CodigoSubvencion ||  this.followupLabels.get("subprojectFFRR")} - ${findSubCode || ''}`, 
                    year: data.Anio,
                    allow: this.formMasters.followupState.find((x: any) => x.Id === Number(data.EstadoAnio))?.Title,
                    allowCode: this.formMasters.followupState.find((x: any) => x.Id === Number(data.EstadoAnio))?.OCTAVIACodigo,
                    country,
                    intLineCode: intLine?.OCTAVIACodigo || '',
                    intLineTitle: intLine?.Title || '',
                    status,
                    startDate: moment.utc(new Date(data.OCTAVIAFechaInicio)).tz(Constants.GeneralFormats.TIME_ZONE).format("DD-MM-YYYY"),
                    endDate: moment.utc(new Date(data.OCTAVIAFechaFinalizacion)).tz(Constants.GeneralFormats.TIME_ZONE).format("DD-MM-YYYY"),
                    projectId: data.IdProyecto,
                    subvCode: data.CodigoSubvencion || '',
                    financer: findSubCode || '',
                    Created: data.Created,
                    canEdit
                })
            }
        }   
        this.view.state.setDataSource(Utilities.sortArrayByKey(newData, "year"));
    }

    public getDataSubProjectsByProject(followData: IFollowup[], masters: any){
        let newData: any[] = []    
        for (const data of followData) {
            let idsFinancers = data.IdFinanciador?.split(", ")
            let findSubCode = null
            if(!!idsFinancers) findSubCode = idsFinancers.map((y: any) => masters.allFinancers.find((x: any) => x.Id === Number(y))?.Title).join(", ")
            let country = !!data.IdPais 
                ? masters.countries.find((x: any) => x.Id === Number(data.IdPais))?.Title 
                : masters.regions.find((x: any) => x.Id === Number(data.IdRegion))?.Title || ''
            let intLine = masters.interventionLines.find((x: any) => x.Id === Number(data.IdLineaIntervencion))
            let status = Number(data.EstadoSubproyecto)
            let validState = this.formMasters.followupState.find((x: any) => x.OCTAVIACodigo === Enums.FollowupState.valid)?.Id

            let yearExist = newData.find((x: any) => x.projectCode === data.PPresCodProy?.trim() && x.year === data.Anio)
            if(status === validState && !yearExist){
                let canEdit = this.getTotalPermissions(country)
                newData.push({
                    id: data.Id,
                    projectCode: data.PPresCodProy?.trim(),
                    projectTitle: data.TituloProyecto?.trim(),
                    subProject: `${data.CodigoSubvencion ||  this.followupLabels.get("subprojectFFRR")} - ${findSubCode || ''}`, 
                    year: data.Anio,
                    allow: this.formMasters.followupState.find((x: any) => x.Id === Number(data.EstadoAnio))?.Title,
                    allowCode: this.formMasters.followupState.find((x: any) => x.Id === Number(data.EstadoAnio))?.OCTAVIACodigo,
                    country,
                    intLineCode: intLine?.OCTAVIACodigo || '',
                    intLineTitle: intLine?.Title || '',
                    status,
                    startDate: moment.utc(new Date(data.OCTAVIAFechaInicio)).tz(Constants.GeneralFormats.TIME_ZONE).format("DD-MM-YYYY"),
                    endDate: moment.utc(new Date(data.OCTAVIAFechaFinalizacion)).tz(Constants.GeneralFormats.TIME_ZONE).format("DD-MM-YYYY"),
                    projectId: data.IdProyecto,
                    subvCode: data.CodigoSubvencion || '',
                    financer: findSubCode || '',
                    Created: data.Created,
                    canEdit
                })
            }
        }   
        this.view.state.setDataSource(Utilities.sortArrayByKey(newData, "year"));
    }

    public getDataSubProjectsByCountry(followData: IFollowup[], masters: any){
        let newData: any[] = []    
        for (const data of followData) {
            let country = !!data.IdPais 
                ? masters.countries.find((x: any) => x.Id === Number(data.IdPais))?.Title 
                : masters.regions.find((x: any) => x.Id === Number(data.IdRegion))?.Title || ''
            let status = Number(data.EstadoSubproyecto)
            let validState = this.formMasters.followupState.find((x: any) => x.OCTAVIACodigo === Enums.FollowupState.valid)?.Id

            let yearExist = newData.find((x: any) => x.country === country && x.year === data.Anio)
            if(status === validState && !yearExist){
                let canEdit = this.getTotalPermissions(country)
                newData.push({
                    id: data.Id,
                    year: data.Anio,
                    allow: this.formMasters.followupState.find((x: any) => x.Id === Number(data.EstadoAnio))?.Title,
                    allowCode: this.formMasters.followupState.find((x: any) => x.Id === Number(data.EstadoAnio))?.OCTAVIACodigo,
                    country,
                    Created: data.Created,
                    canEdit
                })
            }
        }   
        this.view.state.setDataSource(Utilities.sortArrayByKey(newData, "year"));
    }

    public getSubprojectsColumns(){
        return [
            this.getCommonFieldProps("id"),
            this.getCommonFieldProps("project"),
            this.getCommonFieldProps("subProject"),
            this.getCommonFieldProps("year", 0),
            this.getCommonFieldProps("allow"),
            this.getCommonFieldProps("country"),
            this.getCommonFieldProps("intLineTitle")
        ]
    }

    public getSubprojectsByProjectColumns(){
        return [
            this.getCommonFieldProps("id"),
            this.getCommonFieldProps("projectCode"),
            this.getCommonFieldProps("projectTitle"),
            this.getCommonFieldProps("year"),
            this.getCommonFieldProps("allow"),
            this.getCommonFieldProps("country"),
            this.getCommonFieldProps("intLineTitle")
        ]
    }

    public getSubprojectsByCountryColumns(){
        return [
            this.getCommonFieldProps("id"),
            this.getCommonFieldProps("year"),
            this.getCommonFieldProps("allow"),
            this.getCommonFieldProps("country"),
        ]
    }

    public getGridProps(tableId: string){
        return <any> {
            searchPanel: { visible: true },
            filterPanel: { visible: true },
            groupPanel: { visible: true },
            filterRow: { visible: true },
            headerFilter: { visible: true},
            scrolling: { mode: "standard", rowRenderingMode:"standard"  },
            stateStoring: {
                enabled: true,
                type: "localStorage",
                storageKey: "storage_" + tableId
            },
            grouping: { allowCollapsing: true, autoExpandAll: true },
            defaultFilterValue:[Enums.FollowupBasicFields.allow, "=", this.formMasters.followupState.find((x: any) => x.OCTAVIACodigo === Enums.FollowupState.edit)?.Title]
        }
    }

    public getCommonFieldProps(fieldName: string, view?: number, year?: string) {
        const fieldProps = this.view.state.dataColumns.get(fieldName);
        const field: any = {
          id: `${fieldProps?.Id || 0}_followup`,
          caption: fieldProps?.OCTAVIAValorTraduccion || "",
          dataField: fieldProps?.Title || "",
          dataType: fieldProps?.OCTAVIATipoCampo || "string",
          allowEditing: !fieldProps?.SoloLectura,
          alignment: fieldProps?.Alineacion || "center",
          visible: fieldProps?.OCTAVIAVisible || false,
        };

        if(fieldProps?.IndiceGrupo >= 0) field.groupIndex = fieldProps?.IndiceGrupo 

        if(fieldName === Enums.FollowupBasicFields.year && view === 0){
            field.width = 120
        }
        
        return field;
    }

    public getTotalPermissions(country: any){
        const TEAM_CENTRAL = this.params?.[Enums.Params.proyectaCentralTeam]
        const ADMIN_GROUP = this.params?.[Enums.Params.proyectaAdminModule]

        let countryRegionGroup: string = [...this.formMasters?.countries, ...this.formMasters?.regions]?.find((cr: any) => cr.Title === country)?.SGGrupoAD
        let userGroupsId: any[] = this?.currentUser?.userGroups?.map((x: any) => x.id)
        let userGroupsName: any[] = this?.currentUser?.userGroups?.map((x: any) => x.displayName)

        return (userGroupsName?.includes(TEAM_CENTRAL) || userGroupsName?.includes(ADMIN_GROUP) || userGroupsId?.includes(countryRegionGroup))
    }

    public get lastUpdateDate(): any {
        if(!Utilities.isNullEmptyObject(this.currentLabels)){
            let date = new Date();
            date.setHours(1);
            if (this.view.state.dataSource.length > 0) {
                date = this.view.state.dataSource[this.view.state.dataSource.length - 1].Created;
            }
            return this.currentLabels.get("Última Actualización") + " :  " + moment.utc(date).tz(Constants.GeneralFormats.TIME_ZONE).format("MMMM Do YYYY, h:mm a");
        }        
    }
}

export default FollowupPresenter;
